module.exports = __webpack_public_path__ + "assets/images/enabledMic.a8dcd440546de828b15dc29985166164.svg";